import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';

function CreateNewProjectService(token,data) {
    return axios.post(`${CURRENT_API_URL}/projectsDashboard/createNewProject`,data,{
        headers: {
            'Authorization': token,
        }
    }).then(res => {
        console.log(res.data)
        notify.NotifySuccess("The new project has been created successfully.");
        return res.data;        
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while Fetching AllProjects List, please try again later.");
        return false;
    });
}

export default CreateNewProjectService;